import { RichTranslator, useTranslator } from '@bluebeam/react-i18n';
import Switch from 'components/inputs/Switch';
import LoadingAnimation from 'components/LoadingAnimation';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import {
  getAnalyticsOptOut,
  setAnalyticsOptOut,
} from 'services/userProfileService';
import ModalStdHeader from '../ModalStdHeader';

const PrivacySettingsModal = (): ReactElement => {
  const { translate } = useTranslator([
    'privacySettingsModal',
    'buttons',
    'loading',
  ]);
  const [analyticsOn, setAnalyticsOn] = useState(true);
  const [loading, setLoading] = useState(true);
  const [initialSetting, setInitialSetting] = useState(true);
  const context = useContext(AppStoreContext);

  const initalize = async (): Promise<void> => {
    const optOut = await getAnalyticsOptOut();
    setAnalyticsOn(!optOut);
    setLoading(false);
    setInitialSetting(!optOut);
  };

  useEffect(() => {
    initalize();
  }, []);

  const handleCancelClick = (): void => {
    const { clearAllModals } = context.actions;
    clearAllModals();
  };

  const handleSwitchChange = (on: boolean): void => {
    setAnalyticsOn(on);
  };

  const handleCreateUserProfile = async (
    evt: React.FormEvent
  ): Promise<void> => {
    evt.preventDefault();
    const { clearAllModals } = context.actions;
    setAnalyticsOptOut(!analyticsOn);
    clearAllModals();
  };

  return (
    <div id="edit-privacy-settings-modal">
      <ModalStdHeader text={translate('privacySettingsModal:header')} />
      {loading ? (
        <div
          className="flex-center"
          style={{
            height: '478px',
          }}
        >
          <LoadingAnimation pageName={translate('loading:loadingSettings')} />
        </div>
      ) : (
        <div>
          <div className="column">
            <div className="h100 px5 pt8 pb4">
              <div className="pb4" style={{ fontWeight: 300 }}>
                <div className="color-black-2 font-size-7 semi-bold pb2">
                  {translate('privacySettingsModal:titleUsage')}
                </div>
                <div className="color-black-1 font-size-5 pb3">
                  {translate('privacySettingsModal:textParagraph1')}
                  <br />
                  <br />
                  {translate('privacySettingsModal:textParagraph2')}
                  <br />
                  <br />
                  <RichTranslator
                    components={[
                      // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
                      <a
                        target="_blank"
                        href="https://www.bluebeam.com/legal/privacy-policy"
                        rel="noreferrer"
                      />,
                    ]}
                    translationKey="privacySettingsModal:textViewPrivacyPolicy"
                  />
                </div>
              </div>
              <div
                className="p3 mb3 b-solid b-radius-3"
                style={{
                  backgroundColor: 'var(--light-grey-2)',
                  borderColor: 'var(--light-grey-1)',
                  borderWidth: '0.5px',
                }}
              >
                <div className="row justify-between items-center">
                  <div className="column">
                    <div>
                      <div className="color-black-2 font-size-5 semi-bold pb2">
                        {translate('privacySettingsModal:titleShare')}
                      </div>
                    </div>
                    <div className="color-black-1 font-size-4">
                      {analyticsOn ? (
                        <div>
                          {translate('privacySettingsModal:labelShareUsage')}
                        </div>
                      ) : (
                        <div>
                          {translate('privacySettingsModal:labelNoShareUsage')}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="column items-center">
                    <Switch on={analyticsOn} onChange={handleSwitchChange} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-between pr4 pl4 pt3 pb1 mb2 bt-2">
            <button
              id="profile-info-modal-cancel-btn"
              className="btn-lg btn-link mr2"
              onClick={handleCancelClick}
            >
              {translate('buttons:cancel')}
            </button>
            <button
              id="profile-info-modal-confirm-btn"
              className="btn-lg btn-primary"
              onClick={handleCreateUserProfile}
              disabled={initialSetting === analyticsOn}
            >
              {translate('buttons:apply')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

PrivacySettingsModal.modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    top: 'calc(50vh - 240px)',
    left: 'calc(50vw - 265px)',
    bottom: 'initial',
    right: 'initial',
    width: '530px',
    height: '480px',
    padding: '0px',
  },
};

export default PrivacySettingsModal;
